export default function ContactSection() {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-[#ECFDF5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="px-5 py-2 bg-[#10B981] text-white text-sm font-medium rounded-full">
              Contact
            </span>
          </div>
          <h2 className="text-5xl font-bold text-[#065F46] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            お問い合わせ
          </h2>
          <p className="text-lg text-[#666666] mt-6">まずはLINEでお気軽にご相談ください</p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              {/* Contact Info */}
              <div className="bg-gradient-to-br from-[#10B981] to-[#059669] p-12 text-white">
                <h3 className="text-3xl font-bold mb-8" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  訪問整体のご相談はこちら
                </h3>
                
                <div className="space-y-8">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                      <i className="ri-phone-line text-2xl"></i>
                    </div>
                    <div>
                      <p className="text-sm text-white/80 mb-2">電話番号</p>
                      <a href="tel:09018959421" className="text-2xl font-bold hover:text-[#6EE7B7] transition-colors cursor-pointer">
                        090-1895-9421
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                      <i className="ri-mail-line text-2xl"></i>
                    </div>
                    <div>
                      <p className="text-sm text-white/80 mb-2">メールアドレス</p>
                      <a href="mailto:athlon.4448@gmail.com" className="text-lg font-medium hover:text-[#6EE7B7] transition-colors cursor-pointer break-all">
                        athlon.4448@gmail.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                      <i className="ri-line-fill text-2xl"></i>
                    </div>
                    <div>
                      <p className="text-sm text-white/80 mb-2">公式LINE</p>
                      <a 
                        href="https://lin.ee/uGMpYkR" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-lg font-medium hover:text-[#6EE7B7] transition-colors cursor-pointer"
                      >
                        LINEで相談する
                      </a>
                      <p className="text-sm text-white/90 mt-2">
                        お気軽にメッセージください
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                      <i className="ri-time-line text-2xl"></i>
                    </div>
                    <div>
                      <p className="text-sm text-white/80 mb-2">営業時間</p>
                      <p className="text-lg font-medium">10:00〜18:00（応相談）</p>
                      <p className="text-sm text-white/80 mt-1">定休日：日曜日</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                      <i className="ri-map-pin-line text-2xl"></i>
                    </div>
                    <div>
                      <p className="text-sm text-white/80 mb-2">主な対応エリア</p>
                      <p className="text-lg font-medium leading-relaxed">
                        大阪市北部<br />
                        吹田市<br />
                        豊中市
                      </p>
                      <p className="text-sm text-white/90 mt-3">
                        ※その他周辺エリアもご相談ください
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-12 pt-8 border-t border-white/20">
                  <p className="text-sm text-white/80 leading-relaxed">
                    どんな小さなことでも構いません。まずはLINEでお気軽にご相談ください。
                  </p>
                </div>
              </div>

              {/* Image */}
              <div className="flex flex-col h-full min-h-[600px]">
                <div className="flex-1 min-h-[300px] relative overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/029c3862f3c8658aa18362cdd85d72c8/a83d561e40d502beef114568e2a77888.jpeg"
                    alt="施術の様子"
                    className="w-full h-full object-cover"
                    style={{ objectPosition: 'center top' }}
                  />
                </div>
                <div className="relative overflow-hidden">
                  <img
                    src="https://storage.readdy-site.link/project_files/dd63e7f2-2ad5-4550-918c-a85f51c054ca/0f61a90c-1369-417e-9c41-63f7c35a72ae_IMG_8653.png?v=4b2164db82f2f708918380f195dde6e1"
                    alt="施術の様子"
                    className="w-full block"
                    style={{ marginTop: '-42%', marginBottom: '-42%' }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Quick Contact Buttons */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            <a
              href="tel:09018959421"
              className="flex items-center justify-center gap-3 px-8 py-5 bg-[#10B981] text-white text-lg font-bold rounded-full hover:bg-[#059669] transition-all duration-300 shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-2xl"></i>
              <span>電話で相談する</span>
            </a>
            <a
              href="mailto:athlon.4448@gmail.com"
              className="flex items-center justify-center gap-3 px-8 py-5 bg-white text-[#10B981] text-lg font-bold rounded-full border-2 border-[#10B981] hover:bg-[#ECFDF5] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line text-2xl"></i>
              <span>メールで相談する</span>
            </a>
            <a
              href="https://lin.ee/uGMpYkR"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 px-8 py-5 bg-[#06C755] text-white text-lg font-bold rounded-full hover:bg-[#05B04A] transition-all duration-300 shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>LINEで相談する</span>
            </a>
          </div>

          {/* LINE Message */}
          <div className="mt-12 text-center bg-gradient-to-r from-[#ECFDF5] to-[#D1FAE5] rounded-2xl p-8">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-line-fill text-4xl text-[#06C755]"></i>
              <h3 className="text-2xl font-bold text-[#065F46]" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                まずはLINEでお気軽にご相談ください
              </h3>
            </div>
            <p className="text-base text-[#666666] leading-relaxed mb-6">
              お電話が難しい方でも、LINEなら気軽に相談しやすいと思います。<br />
              ご質問やお悩みなど、どんなことでもお答えいたします。
            </p>
            <a
              href="https://lin.ee/uGMpYkR"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-[#06C755] text-white text-lg font-bold rounded-full hover:bg-[#05B04A] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-line-fill text-2xl"></i>
              <span>公式LINEはこちら</span>
              <i className="ri-arrow-right-line text-2xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}